import { BenefitType } from "../enums/BenefitType";
import { UploadedDocument } from "../domain/UploadedDocument";

export type AccidentFormValues = {
    documents: UploadedDocument[],
}

export const defaultAccidentFormValues = {
    benefit: BenefitType.ACCIDENT,
    accident: true,
    documents: [{
        document: '',
        documentContent: '',
        documentType: ''
    }],
}